module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/199/assets/images/1bf7488c747587e036db2316cb6e6aae.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_pencil_active.svg
// module id = 4MiP
// module chunks = 1